<div *ngIf="verificationNeeded">
  <div *ngIf="!isMining">
    <h1 matDialogTitle>This transaction requires the verification of credentials.</h1>
    <ul>
      <li *ngIf="verificationInitiated">{{ verificationInitiated }}</li>
      <li *ngIf="senderCredentialStatus">{{ senderCredentialStatus }}</li>
      <li *ngIf="receiverCredentialStatus">{{ receiverCredentialStatus }}</li>
      <li *ngIf="txAuthorized">{{ txAuthorized }}</li>
    </ul>
  </div>
  <div *ngIf="isMining">
    <h1 matDialogTitle>Waiting for transaction...</h1>
    <mat-spinner style="align:center;"></mat-spinner>
  </div>
</div>

<div *ngIf="isUploadingPolicies">
  <h1 matDialogTitle>Uploading policies to IPFS...</h1>
  <mat-spinner style="align:center;"></mat-spinner>
  <ul style="margin-top: 1em;">
    <li *ngFor="let status of policyUploadStatuses">
      {{ status }}
    </li>
  </ul>
</div>

<div *ngIf="!verificationNeeded && !isUploadingPolicies">
  <div *ngIf="isMining">
    <h1 matDialogTitle>Waiting for transaction...</h1>
    <mat-spinner style="align:center;"></mat-spinner>
  </div>

  <div *ngIf="!isMining">
    <h1 matDialogTitle>Transaction {{ result }}</h1>
    <mat-dialog-content>
      <p *ngIf="result === 'successful'">
        <b>Hash:</b> {{ txHash }}
      </p>
      <p *ngIf="result === 'successful' && createdPolicyHashes.length > 0">
        <b>Policy Layers Created:</b>
        <br />
        <span *ngFor="let hash of createdPolicyHashes; let i = index">
          Layer {{ i + 1 }}: {{ hash }}<br />
        </span>
      </p>
      <p *ngIf="result !== 'successful'">
        Please check your input again and make sure that you can make this transaction.
      </p>
      <p *ngIf="errorMessage" style="color: red;">
        <b>Error:</b> {{ errorMessage }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button type="submit" color="primary" (click)="close()">Close</button>
    </mat-dialog-actions>
  </div>
</div>
